import React from 'react'
import ExcelUpload from '../../components/common/excel-upload/excel-upload'

const PDITamirDurum = () => {
    return (
        <>
            {/* sase	PDI DURUM	PDI TARİHİ	YAZILIM DURUM	YAZILIM TARİHİ	TAMİR DURUM	TAMİR TARİHİ	PARÇA DURUM	PARÇA GELİŞ TARİHİ	AÇIKLAMA */}
            <ExcelUpload
                role_name={"ctyazilimparca_excel_write"}
                requiredColumnsSase={[
                    "sase", "PDI DURUM", "PDI TARİHİ", "YAZILIM DURUM", "YAZILIM TARİHİ", "TAMİR DURUM", "TAMİR TARİHİ", "PARÇA DURUM", "PARÇA GELİŞ TARİHİ", "AÇIKLAMA"
                ]}
                process_type="STOCK_INFO"
                ExcelName={"CT Yazılım/Parça/Tamir Bilgi"}
                Title={"CT Yazılım/Parça/Tamir Bilgi"}
                exampleData={[
                    {
                        "sase": "VR3USHNSSPJ849467", "PDI DURUM": "OK", "PDI TARİHİ": "01.08.2025", "YAZILIM DURUM": "OK", "YAZILIM TARİHİ": "01.08.2025", "TAMİR DURUM": "OK", "TAMİR TARİHİ": "01.08.2025", "PARÇA DURUM": "OK", "PARÇA GELİŞ TARİHİ": "01.08.2025", "AÇIKLAMA": "Açıklama"
                    }
                ]}
            />
        </>
    )
}

export default PDITamirDurum